import { useNotificationHelper } from './toast.utils'

/**
 * Convenience functions for quick notifications (explicit composable import for ESLint).
 */
export const notifySuccess = (title: string, description?: string, content?: string) => {
  const { showSuccess } = useNotificationHelper()
  return showSuccess({ title, description, content })
}

export const notifyError = (title: string, description?: string, content?: string) => {
  const { showError } = useNotificationHelper()
  return showError({ title, description, content })
}

export const notifyWarning = (title: string, description?: string, content?: string) => {
  const { showWarning } = useNotificationHelper()
  return showWarning({ title, description, content })
}

export const notifyInfo = (title: string, description?: string, content?: string) => {
  const { showInfo } = useNotificationHelper()
  return showInfo({ title, description, content })
}
